<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 20L12 4" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M19 12.5L12 20L5 12.5" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
